import { render, staticRenderFns } from "./DeliveryServicepureAnimation.vue?vue&type=template&id=239211ee&scoped=true"
import script from "./DeliveryServicepureAnimation.vue?vue&type=script&lang=js"
export * from "./DeliveryServicepureAnimation.vue?vue&type=script&lang=js"
import style0 from "./DeliveryServicepureAnimation.vue?vue&type=style&index=0&id=239211ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239211ee",
  null
  
)

export default component.exports